import React from 'react';
import QueryTable from 'pages/Dashboard/pages/Contacts/QueryTable';

export default function Overview(query: any) {
  return (
    <div className="relative flex flex-col flex-1 overflow-y-hidden">
      <div className="w-full h-full">
        <QueryTable {...query} />
      </div>
    </div>
  );
}
